import { authenticatedRestClient } from 'helpers/restclient';

export default class DocumentsServices {
	static instance = new DocumentsServices();

	_endpoints = {
		documents: '/api/documents',
		avalaraFormData: '/api/documents/avalara_form_data',
		w9Upsert: '/api/documents/w9_upsert',
		documentFileUpload: (documentId) => `/api/documents/${documentId}/upload`,
	};

	constructor() {
		this.restClient = authenticatedRestClient;
	}

	fetchDocuments = () => {
		return this.restClient.get(this._endpoints.documents);
	};

	fetchAvalaraFormData = () => {
		return this.restClient.get(this._endpoints.avalaraFormData);
	};

	w9Upsert = () => {
		return this.restClient.post(this._endpoints.w9Upsert);
	};

	uploadDocuments = ({ documentId, uploadedDocument }) => {
		const formData = new FormData();
		formData.append('uploaded_document', uploadedDocument);

		return this.restClient.put(this._endpoints.documentFileUpload(documentId), formData, {
			'Content-Type': 'multipart/form-data',
		});
	};
}
